<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Sole to Soul</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgment">Acknowledgment</a></li>
<li id="toc-li-5"><a href="#/text/ch005#sound-tracks">Sound Tracks</a></li>
<li id="toc-li-6"><a href="#/text/ch006#chapter-1-turning-a-blind-eye">Chapter 1:  Turning a Blind Eye</a></li>
<li id="toc-li-7"><a href="#/text/ch007#chapter-2-the-family-box">Chapter 2:   The Family Box</a></li>
<li id="toc-li-8"><span href="#/text/ch008#chapter-3-gifts" title="Link target outside of Sample">Chapter 3:   Gifts</span></li>
<li id="toc-li-9"><span href="#/text/ch009#chapter-4-the-world-is-going-to-hell" title="Link target outside of Sample">Chapter 4:   The World Is Going to Hell</span></li>
<li id="toc-li-10"><span href="#/text/ch010#chapter-5-red-light" title="Link target outside of Sample">Chapter 5:   Red Light</span><ol class="toc"><li id="toc-li-11"><span href="#/text/ch010#janet-nichols-dream-diary" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-12"><span href="#/text/ch011#chapter-6-odd-or-even" title="Link target outside of Sample">Chapter 6:   Odd or Even</span></li>
<li id="toc-li-13"><span href="#/text/ch012#chapter-7-first-date" title="Link target outside of Sample">Chapter 7:   First Date</span></li>
<li id="toc-li-14"><span href="#/text/ch013#chapter-8-on-a-wednesday" title="Link target outside of Sample">Chapter 8:   On a Wednesday</span></li>
<li id="toc-li-15"><span href="#/text/ch014#chapter-9-the-downpour" title="Link target outside of Sample">Chapter 9:   The Downpour</span></li>
<li id="toc-li-16"><span href="#/text/ch015#chapter-10-investigative-road-trip" title="Link target outside of Sample">Chapter 10:   Investigative Road Trip</span><ol class="toc"><li id="toc-li-17"><span href="#/text/ch015#current-day" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-18"><span href="#/text/ch016#chapter-11-the-misfits-road-trip-wheels-keep-spinnin" title="Link target outside of Sample">Chapter 11:   The Misfit’s Road Trip – Wheels Keep Spinnin’</span><ol class="toc"><li id="toc-li-19"><span href="#/text/ch016#section" title="Link target outside of Sample"></span></li>
<li id="toc-li-20"><span href="#/text/ch016#section-1" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-21"><span href="#/text/ch017#chapter-12-my-name-is-jacob" title="Link target outside of Sample">Chapter 12:   My Name Is Jacob</span></li>
<li id="toc-li-22"><span href="#/text/ch018#chapter-13-rainbows-and-conspiracy" title="Link target outside of Sample">Chapter 13:   Rainbows and Conspiracy</span></li>
<li id="toc-li-23"><span href="#/text/ch019#chapter-14-no-other-choice" title="Link target outside of Sample">Chapter 14:   No Other Choice</span></li>
<li id="toc-li-24"><span href="#/text/ch020#chapter-15-the-attack" title="Link target outside of Sample">Chapter 15:   The Attack</span></li>
<li id="toc-li-25"><span href="#/text/ch021#chapter-16-two-hours" title="Link target outside of Sample">Chapter 16:   Two Hours</span></li>
<li id="toc-li-26"><span href="#/text/ch022#chapter-17-caved-in" title="Link target outside of Sample">Chapter 17:   Caved In</span></li>
<li id="toc-li-27"><span href="#/text/ch023#chapter-18-when-the-dust-settles" title="Link target outside of Sample">Chapter 18:   When the Dust Settles</span></li>
<li id="toc-li-28"><span href="#/text/ch024#chapter-19-strings-attached-the-sentinel-rises" title="Link target outside of Sample">Chapter 19:   Strings Attached, the Sentinel Rises</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?0852006c